import { combineReducers } from 'redux';

import { APP_LOCATION_CHANGE } from '../types';
import overlay from './components/overlay-container/reducers';
import actions from './pages/actions/reducers';
import admin from './pages/admin/reducers';
import bookings from './pages/bookings/reducers';
import calendar from './pages/calendar/reducers';
import login from './pages/login/reducers';
import marketing from './pages/marketing/reducers';
import listings from './pages/property/listings/reducers';
import property from './pages/property/reducers';
import register from './pages/register/reducers';

export const globalError = (state = false, action: any) => {
	switch (action.type) {
		case 'GLOBAL_ERROR_SET':
			return true;
		case 'GLOBAL_ERROR_UNSET':
		case APP_LOCATION_CHANGE:
			return false;
		default:
			return state;
	}
};

export interface IViews {
	actions: ReturnType<typeof actions>;
	admin: ReturnType<typeof admin>;
	calendar: ReturnType<typeof calendar>;
	login: ReturnType<typeof login>;
	register: ReturnType<typeof register>;
	property: ReturnType<typeof property>;
	overlay: ReturnType<typeof overlay>;
	globalError: ReturnType<typeof globalError>;
	marketing: ReturnType<typeof marketing>;
	bookings: ReturnType<typeof bookings>;
	listings: ReturnType<typeof listings>;
}

export default combineReducers<IViews>({
	actions,
	admin,
	calendar,
	login,
	register,
	property,
	overlay,
	globalError,
	marketing,
	bookings,
	listings
});
